import { Auth } from 'aws-amplify';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib/types';

export const AUTH_API = {
  signIn: async (username: string, password: string) => {
    try {
      return await Auth.signIn(username, password);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  signOut: async () => {
    try {
      return await Auth.signOut();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  signUp: async (username: string, password: string, email: string) => {
    try {
      const { user } = await Auth.signUp({
        username: email,
        password,
        attributes: {
          email,
        },
      });

      return user;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  confirmSignUp: async (username: string, code: string) => {
    try {
      return await Auth.confirmSignUp(username, code);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  resendConfirmationCode: async (username: string) => {
    try {
      return await Auth.resendSignUp(username);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  forgotPassword: async (username: string) => {
    try {
      return await Auth.forgotPassword(username);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  forgotPasswordSubmit: async (username: string, code: string, new_password: string) => {
    try {
      return await Auth.forgotPasswordSubmit(username, code, new_password);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  socialSignIn: async (socialNetwork: CognitoHostedUIIdentityProvider) => {
    try {
      return await Auth.federatedSignIn({
        provider: socialNetwork,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },

  elamaSignIn: async () => {
    try {
      return await Auth.federatedSignIn({customProvider: "eLama"});
    } catch (error) {
      return Promise.reject(error);
    }
  },

  checkUser: async () => {
    try {
      return await Auth.currentAuthenticatedUser();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  getAccessToken: async () => {
    try {
      const session = await Auth.currentSession();
      return session.getAccessToken().getJwtToken();
    } catch (e: any) {
      return Promise.reject(e);
    }
  },

  getTokenId: async () => {
    try {
      const session = await Auth.currentSession();
      return session.getIdToken().getJwtToken();
    } catch (e: any) {
      return Promise.reject(e);
    }
  },
};
